import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const icpParamRequiredGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  const routeParamList: string[] = ['id', 'egrid'];
  const hasParam: boolean = routeParamList.some((param: string): boolean => !!route.queryParamMap.get(param));
  if (hasParam) {
    return true;
  }
  router.navigate(['home/dashboard']);
  return false;
};
